var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7064 29.0703H4.53125C5.48958 34.3247 11.8147 34.3247 13.5397 34.3247H23.123C31.1091 34.3247 32.7064 35.6509 32.7064 29.0703Z",
    fill: "#B7CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9453 2.36328V7.15495",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7188 2.36328V7.15495",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7209 4.75781C30.0397 5.04531 32.707 7.07378 32.707 14.5807V24.4516C32.707 31.0321 31.1098 34.3224 23.1237 34.3224H13.5404C5.55425 34.3224 3.95703 31.0321 3.95703 24.4516V14.5807C3.95703 7.07378 6.62439 5.06128 11.9431 4.75781H24.7209Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3069 27.2773H4.35547",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3329 12.3438C16.3683 12.3438 14.7072 13.4139 14.7072 15.4903C14.7072 16.4806 15.1704 17.2312 15.8732 17.7104C14.8989 18.2854 14.3398 19.2118 14.3398 20.2979C14.3398 22.2785 15.8572 23.5083 18.3329 23.5083C20.7926 23.5083 22.326 22.2785 22.326 20.2979C22.326 19.2118 21.7669 18.2694 20.7767 17.7104C21.4954 17.2153 21.9426 16.4806 21.9426 15.4903C21.9426 13.4139 20.2975 12.3438 18.3329 12.3438ZM18.3329 16.8799C17.5023 16.8799 16.8954 16.3847 16.8954 15.6021C16.8954 14.8035 17.5023 14.3403 18.3329 14.3403C19.1635 14.3403 19.7704 14.8035 19.7704 15.6021C19.7704 16.3847 19.1635 16.8799 18.3329 16.8799ZM18.3329 21.5278C17.2787 21.5278 16.5121 21.0007 16.5121 20.0424C16.5121 19.084 17.2787 18.5729 18.3329 18.5729C19.3871 18.5729 20.1537 19.1 20.1537 20.0424C20.1537 21.0007 19.3871 21.5278 18.3329 21.5278Z",
    fill: "#FF8165"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1115 37.4965C34.64 37.4965 37.5004 34.6361 37.5004 31.1076C37.5004 27.5792 34.64 24.7188 31.1115 24.7188C27.5831 24.7188 24.7227 27.5792 24.7227 31.1076C24.7227 34.6361 27.5831 37.4965 31.1115 37.4965Z",
    fill: "white",
    stroke: "#A020FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4902 31.1836H28.7305",
    stroke: "#A020FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1094 28.8516V33.6272",
    stroke: "#A020FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentOrder);
export default __webpack_public_path__ + "static/media/AppointmentOrder.1cad774957827cc5b2ae1421fff368fc.svg";
export { ForwardRef as ReactComponent };